import { User } from "../users/localizers"

export const getUserPreviewUrl = (user: Option<User>) =>
  user?.profile.preview ?? user?.profile.image ?? null

export const getUserThumbnail = (user: Option<User>) =>
  user?.profile.thumbnail ?? user?.profile.preview ?? user?.profile.image ?? undefined
